exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#MenuModal .weui-dialog__bd {\n  display: flex;\n  flex-direction: column;\n}\n#MenuModal header {\n  text-align: center;\n  height: 8vh;\n  line-height: 8vh;\n}\n#MenuModal header svg {\n  position: absolute;\n  right: 1px;\n}\n#MenuModal .dishesContainer {\n  overflow: auto;\n}\n#MenuModal .dish {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1.5vw;\n}\n#MenuModal .dish .dishimage {\n  width: 15%;\n  padding-top: 15%;\n  margin-right: 3%;\n  background-size: cover;\n  background-position: center;\n  flex-shrink: 0;\n  box-shadow: 1px 1px 6px 0 rgba(50, 41, 41, 0.1);\n  border-radius: 4px;\n}\n#MenuModal .dish .texts {\n  flex-grow: 2;\n}\n#MenuModal .dish .texts .dishtitle {\n  text-align: left;\n  font-size: 14px;\n  font-weight: 600;\n}\n#MenuModal .dish .texts .dishdescription {\n  text-align: left;\n  color: #2E2E2E;\n  font-size: 14px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/catalogo/reservation/components/MenuModal.less
// module id = 1385
// module chunks = 0